import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, vShow as _vShow, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-a4598c16"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "vue-tl-ticket-purchase-component" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("h4", null, "See you there!", -1 /* HOISTED */))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_PlanPurchaseComponent = _resolveComponent("PlanPurchaseComponent")!
  const _component_LoadingComponent = _resolveComponent("LoadingComponent")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("div", null, [
      _createElementVNode("h2", null, "You've got " + _toDisplayString(_ctx.countCopy), 1 /* TEXT */),
      _hoisted_2,
      (_ctx.canPurchaseMultipleTickets)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            href: "#",
            onClick: _cache[0] || (_cache[0] = _withModifiers(($event: any) => {_ctx.wantToBuyAnotherTicket = true;}, ["prevent"]))
          }, " Purchase another one "))
        : _createCommentVNode("v-if", true),
      _renderSlot(_ctx.$slots, "ticket-purchased-slot", {}, undefined, true)
    ], 512 /* NEED_PATCH */), [
      [_vShow, _ctx.showConfirmation]
    ]),
    _withDirectives(_createElementVNode("div", null, [
      _createVNode(_component_PlanPurchaseComponent, {
        "plan-ids": _ctx.planIds,
        onPlanPurchased: _ctx.handlePlanPurchased,
        onPlanPurchasing: _cache[1] || (_cache[1] = ($event: any) => (_ctx.loading = true))
      }, null, 8 /* PROPS */, ["plan-ids", "onPlanPurchased"])
    ], 512 /* NEED_PATCH */), [
      [_vShow, !_ctx.showConfirmation]
    ]),
    _createVNode(_component_LoadingComponent, { loading: _ctx.loading }, null, 8 /* PROPS */, ["loading"])
  ]))
}